/**
 * TODO:
 * - Check 596ee846 remove enableUint8Utf8 option
 * - Check 19ed32d3 try simulating ctrl + alt for altgr key events
 */

import './globals';
import 'jquery-ui';
import 'jquery-ui/ui/unique-id';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/button';
import './wmks.min';

interface SmartlearnWMKSArgs {
    onSendBytes?: () => unknown;
    onConnect?: () => unknown;
    onDisconnect?: () => unknown;
    onGetNextServerMessage?: () => unknown;
}

/**
 * smartlearn specific adapter for VmWare wmks SDK.
 * Adds compatibility for specific features and hooks to react to events.
 */
export function smartlearnWMKS({
    onSendBytes,
    onConnect,
    onDisconnect,
    onGetNextServerMessage,
}: SmartlearnWMKSArgs = {}): Window['WMKS'] {
    // overwrite from Original: Remove the Safari-Check to enable fullscreen for Safari.
    // refs: b5f067f06155780a56cff07a746d4da1ae445b52
    window.WMKS.UTIL.isFullscreenEnabled = function () {
        return document.fullscreenEnabled ||
            // @ts-ignore
            document.mozFullScreenEnabled ||
            // @ts-ignore
            document.msFullscreenEnabled ||
            // @ts-ignore
            document.webkitFullscreenEnabled
            ? true
            : false;
    };

    // Fix missing variable declarations in wmks v2.2.0 by adding one globally.
    // @ts-ignore
    window.caps = window.caps ?? null;
    // @ts-ignore
    window.type = window.type ?? null;

    // Following functions define interceptors to be called before the super functions
    // code is executed and can be used to add logging.

    const _upstreamSendBytes = window.WMKS.VNCDecoder.prototype._sendBytes;
    window.WMKS.VNCDecoder.prototype._sendBytes = function (
        ...args: unknown[]
    ) {
        onSendBytes?.();
        return _upstreamSendBytes.apply(this, args);
    };

    const _upstreamNextServerMessage =
        window.WMKS.VNCDecoder.prototype._getNextServerMessage;
    window.WMKS.VNCDecoder.prototype._getNextServerMessage = function (
        ...args: unknown[]
    ) {
        onGetNextServerMessage?.();
        return _upstreamNextServerMessage.apply(this, args);
    };

    const _upstreamConnect = window.WMKS.VNCDecoder.prototype.connect;
    window.WMKS.VNCDecoder.prototype.connect = function (...args: unknown[]) {
        onConnect?.();
        return _upstreamConnect.apply(this, args);
    };

    const _upstreamDisconnect = window.WMKS.VNCDecoder.prototype.disconnect;
    window.WMKS.VNCDecoder.prototype.disconnect = function (
        ...args: unknown[]
    ) {
        onDisconnect?.();
        return _upstreamDisconnect.apply(this, args);
    };

    return window.WMKS;
}
